import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import Header from "../dms_common/Header";
import { useCallback, useEffect, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getUTCDate } from "../../services/manageOrderService";
import {
  DownloadSingleReportConfig,
  loadoutsData,
  loadoutStatusConfig,
  popupType,
  ReportFilter,
} from "../../types/types";
import { capitalize } from "../../utils/utils";
import SummaryCard, { SummaryCardBox } from "../dms_common/SummaryCard";
import CustomDataGrid from "../dms_common/CustomDataGrid";
import { Loader } from "../loader/Loader";
import {
  getDownloadSingleReportConfig,
  getGenericModalProps,
  initialGenericModalProps,
  loadOutColumnsMetaData,
} from "./LoadoutUtils";
import { useNavigate } from "react-router-dom";
import "./Loadout.css";
import { GenericPopUp } from "../popup/genericPopUp";
import { useDispatch } from "react-redux";
import { FiltersConfig, GenericModal } from "./common/types";
import {
  fetchLoadoutConfigs,
  printLoadslip,
  setLoadoutConfig,
} from "./pre-seller/PresellerLoadoutService";
import {
  clearAllDataFromLocalDb,
  getDataFromLocalDb,
} from "../../services/dbService";
import {
  deleteLoadout,
  getLoadoutExcelSheet,
  getLoadoutList,
} from "../../services/loadoutService";
import { getConfigData } from "../../services/configurationService";
import { downloadSingleReport } from "../../services/manageReportService";
import { logAnalyticsEvent, logLoadTrace } from "../../firebase";
import CustomGenericModal from "../dms_common/CustomGenericModal";
import useSessionStorageDates from "../dms_common/UseSessionStorageDates";
import { useSelector } from "react-redux";
import { isGapMoreThanNDays } from "../../utils/calenderUtils";
import { getConvertedQty } from "../../features/deliveryConfirmation/DeliveryConfirmationService";
import { safeStringify } from "../dms_common/DmsUtils";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import DayEndNavigator from "../dms_common/DayEndNavigator";
import { getDayEndStatusFromSession } from "../dms_common/DayEndUtils";

export default function Loadout() {
  const dispatch = useDispatch();
  const cart = useSelector((state: any) => state.presellerLoadoutState);

  const { storedStartDate, storedEndDate, storeSessionStorageDates } =
    useSessionStorageDates(
      "deliveryLoadout",
      dayjs().subtract(7, "days"),
      dayjs()
    );

  const [loadoutColumns, setLoadoutColumns] = useState<any>(
    loadOutColumnsMetaData
  );

  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(
    initialGenericModalProps
  );
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openCreateBatchIdForm, setOpenCreateBatchIdForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [searchVal, setSearchVal] = useState<string>("");
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState<number[]>([]);
  const [errorMessageText, setErrorMessageText] = useState<string>("");
  const [
    enableStgExcelLoadoutSheetDownload,
    setEnableStgExcelLoadoutSheetDownload,
  ] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loadNumber, setLoadNumber] = useState<string>("");
  const [filtersLabel, setFiltersLabel] = useState<string>("");
  const [orderTrackingStagesList, setOrderTrackingStagesList] = useState<
    loadoutStatusConfig[]
  >([]);
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
    useState<DownloadSingleReportConfig | null>();
  const [data, setData] = useState<loadoutsData[]>([]);
  const [rows, setRows] = useState<loadoutsData[]>([]);
  const [productData, setProductData] = useState<any>({});
  const [summaryCardBoxes, setSummaryCardBoxes] = useState<SummaryCardBox>({
    displaySummaryCards: false,
    sumaryCardValues: [],
  });
  const navigate = useNavigate();
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const transformData = (row: loadoutsData, productData: any) => {
    const [date, time] = row.loadOutDate.split("T");
    const soldQty = calculateSoldLoadoutQty(row, productData);
    return {
      ...row,
      creationDate: date,
      creationTimeFormatted: time,
      totalSoldCaseQuantity: soldQty.caseQty,
      totalSoldPieceQuantity: soldQty.pieceQty,
      totalSoldOtherQuantity: soldQty.otherQty,
    };
  };

  const calculateSoldLoadoutQty = (loadout: loadoutsData, productData: any) => {
    const soldQty = {
      caseQty: 0,
      pieceQty: 0,
      otherQty: 0,
    };
    loadout.loadOutDetails.forEach((invoiceDetail) => {
      if (
        invoiceDetail?.salesInfo?.invoiceStatus?.toLowerCase() == "invoiced" ||
        invoiceDetail?.salesInfo?.invoiceStatus?.toLowerCase() ==
          "out for delivery"
      ) {
        return;
      }

      invoiceDetail.loadOutItems.forEach((skuDetails: any) => {
        const convertedQtyData = getConvertedQty(
          {
            caseQty: skuDetails?.caseQty,
            pieceQty: skuDetails?.pieceQty,
            otherQty: skuDetails?.otherQty,
          },
          {
            caseQty: skuDetails?.caseQtyLeft,
            pieceQty: skuDetails?.pieceQtyLeft,
            otherQty: skuDetails?.otherQtyLeft,
          },
          productData[skuDetails.batchCode]
        );
        soldQty.caseQty += convertedQtyData.caseQty;
        soldQty.pieceQty += convertedQtyData.pieceQty;
        soldQty.otherQty += convertedQtyData.otherQty;
      });
    });
    return soldQty;
  };

  const confirmDelete = async (loadNumberToDelete: string) => {
    if (!loadNumberToDelete) return;

    try {
      setLoader(true);

      await deleteLoadout(loadNumberToDelete);

      // Update the frontend arrays without refetching
      setRows((prevRows) =>
        prevRows.filter((row) => row.loadNumber !== loadNumberToDelete)
      );
      setData((prevData) =>
        prevData.filter((row) => row.loadNumber !== loadNumberToDelete)
      );

      // Update summary cards
      const updatedRows = rows.filter(
        (row) => row.loadNumber !== loadNumberToDelete
      );
      updateSummaryCardBoxes(updatedRows);

      setGenericModalProps(
        getGenericModalProps(
          "success",
          `Loadout ${loadNumberToDelete} deleted successfully.`
        )
      );
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Loadout: Failed to delete loadout",
        `Loadout: Failed to delete loadout while confirmDelete in Loadout.tsx`,
        safeStringify({ error })
      );
      setGenericModalProps(
        getGenericModalProps(
          "error",
          "Failed to delete loadout. Please try again."
        )
      );
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = async (loadNumber: string) => {
    setGenericModalProps({
      type: "negative",
      message: `Are you sure you want to delete loadout ${loadNumber}?`,
      leftButtonText: "Delete",
      rightButtonText: "Cancel",
      open: true,
      onLeftButtonClick: () => confirmDelete(loadNumber),
      onRightButtonClick: () => setGenericModalProps(initialGenericModalProps),
    });
  };

  const updateSummaryCardBoxes = (data: loadoutsData[]) => {
    setSummaryCardBoxes((prev: any) => {
      const inDraftCount = data.filter(
        (row) => row.status === "IN-DRAFT"
      ).length;
      const deliveredCount = data.filter(
        (row) => row.status === "DELIVERED"
      ).length;
      const inTransitCount = data.filter(
        (row) => row.status === "IN-TRANSIT"
      ).length;

      return {
        ...prev,
        sumaryCardValues: prev?.sumaryCardValues?.map(
          (box: SummaryCardBox, index: number) => {
            let boldHeading = 0;
            if (index === 0) {
              boldHeading = data.length;
            } else if (index === 1) {
              boldHeading = inDraftCount;
            } else if (index === 2) {
              boldHeading = deliveredCount;
            } else if (index === 3) {
              boldHeading = inTransitCount;
            }
            return {
              ...box,
              boldHeading,
            };
          }
        ),
      };
    });
  };

  const fetchConfigs = useCallback(async () => {
    const loadoutSummaryCards = await fetchLoadoutConfigs(
      "loadoutSummaryCards"
    );
    setSummaryCardBoxes(loadoutSummaryCards);

    const loadoutStages = await fetchLoadoutConfigs("loadoutStages");
    setOrderTrackingStagesList(loadoutStages);

    const loadoutConfigValues = await fetchLoadoutConfigs("loadoutConfigs");
    setLoadoutConfig(loadoutConfigValues, dispatch);

    setEnableStgExcelLoadoutSheetDownload(
      loadoutConfigValues?.Preseller?.EnableStgExcelLoadoutSheetDownload ??
        false
    );

    const loadslipReportIdConfig = await getConfigData(
      "loadout_configuration",
      "loadoutReportId"
    );

    const filters = [{ key: "loadNumber", value: "" }];

    if (loadoutConfigValues?.Preseller?.LoadslipGroupByField) {
      filters.push({
        key: "groupByField",
        value: loadoutConfigValues?.Preseller?.LoadslipGroupByField,
      });

      if (loadoutConfigValues?.Preseller?.LoadslipColumnLabel) {
        filters.push({
          key: "columnLabel",
          value: loadoutConfigValues?.Preseller?.LoadslipColumnLabel,
        });
      }
    }

    if (loadoutConfigValues?.Preseller?.LoadslipMultipleFilters?.length > 0) {
      setFiltersLabel(
        loadoutConfigValues?.Preseller?.LoadslipMultipleFilters?.map(
          (filter: FiltersConfig) => filter.label
        )
      );
    }

    setDownloadSingleReportConfig(
      getDownloadSingleReportConfig(
        loadslipReportIdConfig[0]?.configValue,
        filters
      )
    );

    const actions = [];
    if (loadoutConfigValues?.Preseller?.LoadoutActions?.DisplayEyeIcon)
      actions.push("view");
    if (loadoutConfigValues?.Preseller?.LoadoutActions?.DisplayDownloadIcon)
      actions.push("download");
    setLoadoutColumns({
      ...loadOutColumnsMetaData,
      Actions: actions,
    });
  }, []);

  const getTableData = useCallback(
    async (startDate: Dayjs, endDate: Dayjs, productData: any) => {
      try {
        dispatch({ type: "RESET_PRESELLER_LOADOUT_WITHOUT_CONFIG" });
        clearAllDataFromLocalDb("Cart");
        const start = getUTCDate(startDate, "start");
        const end = getUTCDate(endDate, "end");

        let responseArray: loadoutsData[] = [];
        let page = 0;
        let hasMoreData = true;

        while (hasMoreData) {
          const response = await getLoadoutList(start, end, true, page);
          const content = response?.data?.content || [];

          if (content.length < 1000) {
            hasMoreData = false; // Stop if data on current page is less than 1000
          }
          content.forEach((item: any) => {
            if (
              item?.status?.toLowerCase() === "in-draft" ||
              item?.status?.toLowerCase() === "in-transit" ||
              item?.status?.toLowerCase() === "delivered"
            ) {
              responseArray.push({
                id: item.loadNumber,
                downloadId: item.loadNumber,
                loadNumber: item.loadNumber,
                type: item.type === "PRE-SELLER" ? "Pre-seller" : "RSU",
                routeId: item.routeCode,
                vehicleId: item.vehicleId,
                loadOutDate: item.loadOutDate,
                salesRepName: item.salesRepName,
                salesmanId: item.salesmanId,
                supplier: item.supplier,
                loadoutSource: item.loadoutSource,
                loadOutDetails: item.loadOutDetails,
                deliveryStartDate: item.deliveryStartDate,
                deliveryEndDate: item.deliveryEndDate,
                invoiceCreationStartDate: item.invoiceCreationStartDate,
                invoiceCreationEndDate: item.invoiceCreationEndDate,
                totalAmount: item.totalAmount,
                totalCaseQty: item.totalCaseQty,
                totalPieceQty: item.totalPieceQty,
                totalOtherQty: item.totalOtherQty,
                totalCaseLeftQty: item.totalCaseLeftQty,
                totalPieceLeftQty: item.totalPieceLeftQty,
                totalOtherLeftQty: item.totalOtherLeftQty,
                status: item.status,
                showEyeIcon:
                  item?.status === "IN-TRANSIT" || item?.status === "DELIVERED"
                    ? true
                    : false,
                showDeleteIcon: item?.status === "IN-DRAFT",
              });
            }
          });
          page++; // Continue to the next page
        }

        const transformedData = responseArray.map((row: loadoutsData) =>
          transformData(row, productData)
        );
        transformedData.sort((a: loadoutsData, b: loadoutsData) =>
          dayjs(b.loadOutDate).diff(dayjs(a.loadOutDate))
        );
        setRows(transformedData);
        setData(transformedData);
        updateSummaryCardBoxes(transformedData);
        setStatusFilter("");
      } catch (e) {
        console.error("error", e);
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Loadout: Failed to retrieve loadout data",
          `Loadout: Failed to retrieve loadout data while getTableData in Loadout.tsx`,
          safeStringify({ error: e })
        );
        setGenericModalProps(
          getGenericModalProps(
            "error",
            "Failed to retrieve loadout data. Please try again later."
          )
        );
      } finally {
        setLoader(false);
      }
    },
    [dispatch, setRows, setData, updateSummaryCardBoxes]
  );

  const init = async () => {
    setLoader(true);
    let productData: any = {};
    try {
      productData = (await getDataFromLocalDb("Product")).data[0].data;
      setProductData(productData);
    } catch (e) {
      await sendSlackAlert(
        SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
        "Loadout: Failed to retrieve product data from local db",
        `Loadout: Failed to retrieve product data from local db while init in Loadout.tsx`,
        safeStringify({ error: e })
      );
      console.log("error", e);
    }
    await Promise.allSettled([
      fetchConfigs(),
      getTableData(startDate, endDate, productData),
    ]).finally(() => {
      setLoader(false);
    });
  };

  const handleCreateButtonClick = () => {
    if (!cart?.loadoutConfig?.rsuRouteMaintained) {
      navigate("preseller");
    } else {
      setOpenCreateBatchIdForm((prev) => !prev);
    }
  };

  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    logLoadTrace(init, "delivery_loadout_home_page_load_time");
  }, []);

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const isStartDateIsGreaterThanEndDate = (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs
  ) => {
    const diff = endDate.diff(startDate);
    return diff < 0;
  };

  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") || "{}"
  );
  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  function canWeMakeRequest() {
    if (
      startDate &&
      endDate &&
      isGapMoreThanNDays(startDate, endDate, validDateRange)
    ) {
      openPopup(
        `You can't select date range more than ${validDateRange} days!`,
        "Alert"
      );
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      openPopup("To Date should be greater than from date.", "Alert");
      return false;
    }
    return true;
  }

  const handleApply = async () => {
    if (canWeMakeRequest()) {
      try {
        setLoader(true);
        logAnalyticsEvent("delivery_loadout_date_filter", {
          distributor_id: JSON.parse(localStorage.authContext).user.loginId,
          loadout_start_date_selected: startDate,
          loadout_end_date_selected: endDate,
        });
        storeSessionStorageDates(startDate, endDate);
        await getTableData(startDate, endDate, productData);
      } catch (error) {
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Loadout: Failed to apply date filter",
          `Loadout: Failed to apply date filter while handleApply in Loadout.tsx`,
          safeStringify({ error: error })
        );
        console.error(error);
      } finally {
        setLoader(false);
      }
    }
  };

  const handleClearAll = () => {
    const date = dayjs();
    setStartDate(date.subtract(7, "day"));
    setEndDate(date);
    storeSessionStorageDates(date.subtract(6, "day"), date);
    getTableData(date.subtract(7, "day"), date, productData);
  };

  useEffect(() => {
    if (searchVal.length > 1) {
      const finalData = data
        .filter((eachRow: any) => {
          const { loadNumber, routeId, vehicleId, salesmanId, salesRepName } =
            eachRow;
          const searchValue = searchVal?.toLowerCase();
          return (
            loadNumber?.toString().toLowerCase().includes(searchValue) ||
            routeId?.toString().toLowerCase().includes(searchValue) ||
            vehicleId?.toString().toLowerCase().includes(searchValue) ||
            salesmanId?.toString().toLowerCase().includes(searchValue) ||
            salesRepName?.toString().toLowerCase().includes(searchValue)
          );
        })
        ?.map((row) => transformData(row, productData));

      setRows(finalData);
    } else setRows(data);
  }, [searchVal]);

  const handleStatusFilterChange = (value: string) => {
    logAnalyticsEvent("delivery_loadout_status_filter", {
      distributor_id: JSON.parse(localStorage.authContext).user.loginId,
      loadout_filter_selected: value,
    });
    setStatusFilter(value);

    if (value === "" || value === "ALL") {
      setRows(data);
      updateSummaryCardBoxes(data);
    } else {
      const filtered = data.filter(
        (row) => row?.status?.toLowerCase() === value.toLowerCase()
      );
      setRows(filtered);
      updateSummaryCardBoxes(filtered);
    }
  };

  const onDownloadGeneric = async (downloadId: string) => {
    if (enableStgExcelLoadoutSheetDownload) {
      try {
        if (isDownloading) return;
        setIsDownloading(true);
        setSnackbarMessage("Your loadslip report will be downloaded shortly.");
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ")
          .replace(/:/g, "-");
        await getLoadoutExcelSheet(
          downloadId,
          "dms_loading_sheet",
          "Loading Sheet " + timestamp + ".csv"
        );
        await getLoadoutExcelSheet(
          downloadId,
          "dms_loadout_items",
          "Loading Sheet Product Wise " + timestamp + ".csv"
        );
      } catch (e) {
        console.error("Download failed", e);
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Loadout: Failed to download loadslip report",
          `Loadout: Failed to download loadslip report while onDownloadGeneric in Loadout.tsx`,
          safeStringify({ error: e })
        );
        openPopUp(
          "Something went wrong while downloading loadslip report",
          "Error"
        );
        setIsDownloading(false);
      } finally {
        setIsDownloading(false);
      }
    } else {
      if (isDownloading || !downloadSingleReportConfig) return;

      try {
        setIsDownloading(true);
        setSnackbarMessage("Your loadslip will be downloaded shortly.");

        const config: DownloadSingleReportConfig = {
          ...downloadSingleReportConfig,
          filters: downloadSingleReportConfig.filters.map(
            (filter: ReportFilter, index: number) => ({
              key: filter.key,
              value: index === 0 ? downloadId : filter.value,
            })
          ),
        };

        await downloadSingleReport(config, setSnackbarOpen, setIsDownloading);
      } catch (e) {
        await sendSlackAlert(
          SlackChannel.DMS_SECONDARY_UI_NOTIFICATION,
          "Loadout: Failed to download loadslip report",
          `Loadout: Failed to download loadslip report while onDownloadGeneric in Loadout.tsx`,
          safeStringify({ error: e })
        );
        console.error("Download failed", e);
      } finally {
        setIsDownloading(false);
      }
    }
  };

  const dayEndObj = getDayEndStatusFromSession();

  const openPopUp = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const tableWidth =
    cart?.loadoutConfig?.loadoutActions?.DisplayDownloadIcon &&
    cart?.loadoutConfig?.loadoutActions?.DisplayEyeIcon
      ? 0.723
      : cart?.loadoutConfig?.loadoutActions?.DisplayDownloadIcon ||
        cart?.loadoutConfig?.loadoutActions?.DisplayEyeIcon
      ? 0.76
      : 0.8;

  return (
    <div className="manage_loadout_parent">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      {showPopup ? (
        <CustomGenericModal
          type=""
          message={filtersLabel}
          modalOpen={showPopup}
          onClose={() => {
            setShowPopup(false);
            setSelectedCheckboxes([]);
          }}
          errorMessages={false}
          addCheckBox={true}
          selectedCheckboxes={selectedCheckboxes}
          errorMessageText={errorMessageText}
          setSelectedCheckboxes={(selectedCheckboxes: number[]) => {
            setSelectedCheckboxes(selectedCheckboxes);
            setErrorMessageText("");
          }}
          headerText="Print Loadslip"
          subHeaderText="Select the Loadslip format you want to print"
          headerIcon={{
            headerIconType: "print",
            width: "100%",
          }}
          leftButtonText="Print"
          onLeftButtonClick={() => {
            if (selectedCheckboxes.length === 0) {
              setErrorMessageText(
                "Please select at least one format to download the Loadout Slip."
              );
              return;
            } else {
              setErrorMessageText("");
            }
            printLoadslip(
              loadNumber ?? "",
              cart,
              setSnackbarOpen,
              setIsDownloading,
              isDownloading,
              openPopUp,
              setSnackbarMessage,
              cart?.loadoutConfig?.loadSlipConfigs,
              selectedCheckboxes.map(
                (idx) =>
                  cart?.loadoutConfig?.loadslipMultipleFilters?.[idx]?.key
              )
            );
          }}
        />
      ) : genericModalProps?.open ? (
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          onClose={() => setGenericModalProps(initialGenericModalProps)}
        />
      ) : null}
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage ?? "Your loadslip will be downloaded shortly."}
        </Alert>
      </Snackbar>
      <Box sx={{ position: "relative" }}>
        <Header
          title={"Loadout Creation"}
          searchFunction={setSearchVal}
          onRefresh={init}
          createBtnLabel={"Create New Loadout"}
          handleCreateBtnClick={handleCreateButtonClick}
          buttonRef={buttonRef}
        />
        {openCreateBatchIdForm && (
          <Box
            sx={{
              position: "absolute",
              top: buttonRef.current
                ? buttonRef.current.offsetTop +
                  buttonRef.current.offsetHeight +
                  5
                : 0,
              left: buttonRef.current ? buttonRef.current.offsetLeft : 0,
              border: "1px solid #EBEBEB",
              borderRadius: "5px",
              backgroundColor: "#fff",
              width: buttonRef.current ? buttonRef.current.offsetWidth : "auto",
              zIndex: 10,
            }}
          >
            <RadioGroup
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              sx={{ paddingLeft: "0.5rem" }}
            >
              <FormControlLabel
                value="Pre-seller"
                control={
                  <Radio
                    size="small"
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                }
                label="Pre-seller"
                sx={{
                  borderBottom: "1.8px dashed #EBEBEB",
                  color: "#606060",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "13px",
                  },
                  mr: 0,
                  letterSpacing: 0,
                  marginLeft: "-9px",
                }}
                onClick={() => navigate("preseller")}
              />
              <FormControlLabel
                value="RSU"
                control={
                  <Radio
                    size="small"
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: "0.9rem",
                      },
                    }}
                  />
                }
                label="RSU"
                onClick={() => navigate("rsu")}
                sx={{
                  color: "#606060",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "13px",
                  },
                  mr: 0,
                  letterSpacing: 0,
                }}
              />
            </RadioGroup>
          </Box>
        )}
      </Box>

      <div className="dms_toolbar">
        <div className="manage_order_support_utility_dates_manageOrder">
          <Stack spacing={2.8} direction={"row"}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              className="manage_order_dateEnter"
            >
              <DatePicker
                label="From Date"
                inputFormat="DD-MM-YYYY"
                value={startDate}
                maxDate={dayjs()}
                onChange={(value) => {
                  if (value) {
                    setStartDate(value);
                  }
                }}
                renderInput={(props) => (
                  <TextField {...props} disabled size="small" />
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                inputFormat="DD-MM-YYYY"
                value={endDate}
                maxDate={dayjs()}
                onChange={(value) => {
                  if (value) {
                    setEndDate(value);
                  }
                }}
                renderInput={(props) => (
                  <TextField {...props} disabled size="small" />
                )}
              />
            </LocalizationProvider>
          </Stack>
          <div className="manage_order_reset_and_apply_button_manage_order">
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                backgroundColor: "#237C9D",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
              onClick={() =>
                logLoadTrace(
                  handleApply,
                  "delivery_loadout_home_page_load_time"
                )
              }
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                backgroundColor: "#f0fbff",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
              onClick={handleClearAll}
            >
              Reset
            </Button>
          </div>
        </div>
        <FormControl className="manage_order_filter">
          <Select
            labelId="dropdown_label"
            value={statusFilter}
            size="small"
            displayEmpty
            sx={{
              minWidth: "176px",
              marginLeft: "10px",
              fontSize: "14px",
              border: "1px solid #DEDEDE",
              borderRadius: "8px",
              "&.Mui-focused": {
                border: "1px solid #DEDEDE",
                boxShadow: "none",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            onChange={(e) => {
              handleStatusFilterChange(e.target.value);
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  padding: 0,
                  boxShadow: "none",
                  border: "1px solid #DEDEDE",
                  borderRadius: "8px",
                },
              },
              MenuListProps: {
                sx: {
                  padding: "7px 0",
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <span style={{ color: "#AFAFAF", fontSize: "12px" }}>
                    Filter by Status
                  </span>
                );
              }
              const item = orderTrackingStagesList.find(
                (d) => d.id === selected
              );
              return item ? (
                <div className="dropdown_selected_item">
                  {item?.dmsLabel ?? ""}
                </div>
              ) : null;
            }}
          >
            {orderTrackingStagesList?.map((item, index) => (
              <MenuItem
                key={item.id}
                value={item.id}
                className="menuItem-test-debug"
                sx={{
                  padding: "2px 0px",
                  borderBottom:
                    index !== orderTrackingStagesList.length - 1
                      ? "1.5px dashed #EBEBEB"
                      : "none",
                  margin: "0 10px",
                }}
              >
                <div className="loadout_dropdown_menu_item">
                  <span>{capitalize(item?.dmsLabel ?? "")}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {loader ? (
        <Loader sx={{ position: "absolute", top: "55%" }} />
      ) : (
        <>
          <div style={{display: 'flex', justifyContent: "space-between", alignItems: "center", width :"100%"}}>
            {summaryCardBoxes?.displaySummaryCards && (
              <SummaryCard
                totalHeight="69"
                summaryTitle="Loadout Summary"
                summaryTitleBgColor="#FFF9EF"
                box={summaryCardBoxes?.sumaryCardValues}
              />
            )}
            {
              (dayEndObj && dayEndObj.isDayEndInProgress) && (
                <DayEndNavigator currentPage="loadouttable"/>
              )
            }
          </div>
          <CustomDataGrid
            rows={rows}
            columnsMetaData={
              cart?.loadoutConfig.enableVehicleAssignment &&
              cart?.loadoutConfig.enableSalesmanAssignment
                ? loadoutColumns
                : cart?.loadoutConfig.enableSalesmanAssignment
                ? {
                    ...loadoutColumns,
                    columns: loadoutColumns.columns.filter(
                      (column: any) => column?.headerName !== "Vehicle No."
                    ),
                  }
                : cart?.loadoutConfig.enableVehicleAssignment
                ? {
                    ...loadoutColumns,
                    columns: loadoutColumns.columns.filter(
                      (column: any) =>
                        column?.headerName !== "Salesman Name & ID"
                    ),
                  }
                : {
                    ...loadoutColumns,
                    columns: loadoutColumns.columns.filter(
                      (column: any) =>
                        column?.headerName !== "Salesman Name & ID" &&
                        column?.headerName !== "Vehicle No."
                    ),
                  }
            }
            orderStatusConfig={orderTrackingStagesList}
            redirectUrl="/delivery/loadouts/preseller/viewLoadout/"
            tableWidth={tableWidth}
            downloadSingleReportConfig={downloadSingleReportConfig}
            onDownloadGeneric={
              filtersLabel.length > 0
                ? (downloadId: string) => {
                    setShowPopup(true);
                    setLoadNumber(downloadId);
                  }
                : onDownloadGeneric
            }
            onDeleteFunction={handleDelete}
          />
        </>
      )}
    </div>
  );
}
